module.exports = __webpack_public_path__ + "img/demo_verticales.a581e91c.jpg";